export const SoundPaths = {
  WON_FX: "fx/fx-won",
  GAME_OVER_FX: "fx/fx-game-over",
};
